export const AdminMenuEnum = {
  PARTNER_ACCESS_LOG: 1,
  HANDOVER_LOG: 2
};
